<template>
    <el-drawer
        :title="!data ? '添加员工' : '编辑员工'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
                <!-- <el-form-item prop="accName" label="账号:">
                    <el-input
                        v-model="formData.accName"
                        placeholder="请输入账号"
                    ></el-input>
                </el-form-item> -->
                <el-form-item prop="nameZh" label="姓名:">
                    <el-input
                        v-model="formData.nameZh"
                        placeholder="请输入姓名"
                        :maxlength="10"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="tel" label="手机:">
                    <el-input
                        v-model="formData.tel"
                        placeholder="请输入手机"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="mail" label="邮箱:">
                    <el-input
                        v-model="formData.mail"
                        placeholder="请输入邮箱"
                        :maxlength="100"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <!-- 部门：非必填，最多40字符 -->
                <el-form-item prop="department" label="部门:">
                    <el-input
                        v-model="formData.department"
                        placeholder="请输入部门"
                        :maxlength="40"
                        size="medium"
                    ></el-input>
                </el-form-item>
				<el-form-item prop="pwd" label="登录密码:">
					
					<span slot="label">登录密码: <small>8-40个字符，且必须包含至少1位字母、1位数字、1位特殊字符（! @ # $ % ^ & *）</small></span>
					<el-input v-model="formData.pwd" placeholder="请输入密码" type="password" size="medium" maxlength="40" show-password  auto-complete="new-password"></el-input>
					<span> <small>登录密码同登录专业版的密码一致</small></span>
					
				   
				</el-form-item>
                <!-- <el-form-item prop="roleIdList" label="角色:">
                    <el-select
                        v-model="formData.roleIdList"
                        placeholder="请选择角色"
                        multiple
                    >
                        <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.roleName"
                            :value="item.id"
                            :value-key="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <!-- <el-form-item
                    prop="k3cloudUserNumbers"
                    label="金蝶员工编码:"
                >
                    <el-input
                        v-model="formData.k3cloudUserNumbers"
                        placeholder="请输入金蝶员工编码"
                        :maxlength="20"
                        size="medium"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="k3cloudUserId" label="金蝶员工内码:">
                    <el-input
                        v-model="formData.k3cloudUserId"
                        placeholder="请输入金蝶员工内码"
                        :maxlength="20"
                        size="medium"
                    ></el-input>
                </el-form-item> -->
                <el-form-item prop="status" label="状态:">
                    <el-radio-group v-model="formData.status" size="medium">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="loading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
// import { getRoleAll } from "@/assets/js/commonApi";
const defaultFormData = {
    // accName: "",
    nameZh: "",
    tel: "",
    mail: "",
    department: "",
	pwd:"",
    // roleIdList: [],
    k3cloudUserNumbers: "",
    k3cloudUserId: "",
    status:1
}
export default {
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
		const validatePassword = (rule, value, callback) => {
		     const _reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,40}$/ // 至少1位字母、1位数字、1位特殊字符(!@#$%^&*)
	     if (!_reg.test(value)) {
	         callback(new Error("密码必须8-40个字符，且必须包含至少1位字母、1位数字、1位特殊字符（! @ # $ % ^ & *）"));
		     } else {
		         callback();
		     }
		 }
        return {
            drawerShow: false,
            loading: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                // accName: [{ required: true, message: "请输入账号" }],
                nameZh: [{ required: true, message: "请输入姓名" }],
                tel: [
                    { required: true, message: "请输入手机" },
                    { validator: this.$utils.validatePhone },
                ],
                mail: [
                    { required: true, message: "请输入邮箱" },
                    { type: "email", message: "请输入正确的邮箱地址" },
                ],
				pwd:[
				    {required:true,message:'请填写登录密码'},
					{validator:validatePassword}
				],				
                // roleIdList: [{ required: true, message: "请选择角色" }],
            },
            // roleList: [],
        };
    },
    created() {
        // this.getRoleList();
    },
    watch: {
        data(val) {
            this.formData = val ? {
                ...val,
                pwd: '' // 编辑时密码不默认填充
                /*,roleIdList:[]*/
            } : {...defaultFormData};
            // if (val) {
            //     val.roleList.map((item) => {
            //         this.formData.roleIdList.push(item.id);
            //     });
            // } else {
            //     this.formData.roleIdList = [];
            // }
        },
    },
    methods: {
        //获取角色
        // getRoleList() {
        //     getRoleAll().then((res) => {
        //         const { state, result } = res.data;
        //         if (state == 1 && result) {
        //             this.roleList = result;
        //         }
        //     });
        // },
        close() {
            this.formData = {...defaultFormData};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = this.formData.id
                        ? "/adminUser/edit"
                        : "/adminUser/add";
                    this.loading = true;
                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>